export type XpointAction =
  | 'PLACE_BET'
  | 'PLACE_ENTRY'
  | 'LOGIN'
  | 'BIOMETRIC_LOGIN'
  | 'REGISTRATION'
  | 'DEPOSIT'
  | 'WITHDRAWAL';

export interface XpointVerifyParams {
  action: XpointAction;
  userIdentifier: string;
  xpointKey: string;
}

export interface XpointVerifyResult {
  status: 'allowed' | 'blocked' | 'error';
  jwt: string | null;
}

// Fake JWT returned when `Config.CONFIG.xpointDisabled` is set, so the app can be
// run/tested locally without a real Xpoint check. Single source of truth so every
// caller behaves identically under this bypass.
export const XPOINT_LOCAL_TEST_JWT = 'aurelmegatoken';
